/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ExtrasValueRegexQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ExtrasValueRegexQueryOperator");
    }

    getFixupPrototypeFunction() { return ExtrasValueRegexQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ExtrasValueRegexQueryOperator>): ExtrasValueRegexQueryOperator {
        let obj = Object.assign(new ExtrasValueRegexQueryOperator(), model);
        ExtrasValueRegexQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ExtrasValueRegexQueryOperator>): ExtrasValueRegexQueryOperator {
        if (!model) return null;
        return ExtrasValueRegexQueryOperator.newInstance(<ExtrasValueRegexQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ExtrasValueRegexQueryOperator) {
        if (!obj) return;

        models.ExtrasValueRegexQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ExtrasValueRegexQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ExtrasValueRegexQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.extras_value_regex) {
            models.Regex.fixupPrototype(this.extras_value_regex);
        }
    }

    /**
     * Extra key to identify which field to select
     */
    extra_key: string;

    /**
     * Include response that follows the regex pattern
     */
    extras_value_regex: models.Regex;

}
